import {Component, input, output} from '@angular/core';
import {TableModule} from 'primeng/table';
import {TranslatePipe} from '@ngx-translate/core';
import {DatePipe} from '@angular/common';
import {DevDirective} from '../../../../directives/dev.directive';
import {ElciaButton} from '../../../../components/buttons/button/button';
import {InvoicePeppolSummary} from '../../../../../api';

@Component({
  selector: 'elcia-outgoing-invoices-grid',
  imports: [TableModule, TranslatePipe, DatePipe, DevDirective, ElciaButton],
  templateUrl: './outgoing-invoices-grid.component.html',
  styleUrl: './outgoing-invoices-grid.component.scss',
})
export class OutgoingInvoicesGrid {
  outgoingInvoices = input.required<InvoicePeppolSummary[]>();

  onDownloadInvoice = output<InvoicePeppolSummary>();
  onDownloadAttachment = output<InvoicePeppolSummary>();

  protected downloadInvoicePeppol(invoice: InvoicePeppolSummary): void {
    this.onDownloadInvoice.emit(invoice)
  }

  protected downloadAttachments(invoice: InvoicePeppolSummary): void {
    this.onDownloadAttachment.emit(invoice);
  }
}
